import { Injectable, inject } from '@angular/core';
import { StepDTO } from '../dto/common-dto';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * This service is responsible for getting the status data.
 */
@Injectable({ providedIn: 'root' })
export class StatusDataService {
  // Inject HttpClient.
  private readonly http = inject(HttpClient);

  // Stores the API URL.
  private readonly API_URL = environment.UrlEndpoints.statusData;

  /**
   * Get the status data.
   *
   * @returns An observable of the data.
   */
  getStatusData(): Observable<StepDTO[]> {
    return this.http.get<StepDTO[]>(this.API_URL);
  }
}
